__webpack_require__.p = "https://js-static.iimjobs.com/production/21.4.0/_next/";